import get from 'lodash/get';
import moment from 'moment';
import set from 'lodash/set';

const transformTestData = (data) => {
  const payload = {
    countryListId: get(data, 'countryListId.id'),
    testItemId: get(data, 'testItemId.value'),
    citationId: get(data, 'citationId.id', null),
    reportId: data.reportId,
    serviceProviderId: get(data, 'serviceProviderId.value'),
    result: data.result,
    expiryDate: moment.isMoment(data.expiryDate)
      ? data.expiryDate.format('YYYY-MM-DD')
      : data.expiryDate,
    testDate: moment.isMoment(data.testDate) ? data.testDate.format('YYYY-MM-DD') : data.testDate,
  };
  if (data.id) {
    set(payload, 'id', data.id);
  }
  return payload;
};
const transformCertificateData = (data) => {
  const payload = {
    certificateTypeId: get(data, 'certificateTypeId.value'),
    customCertificateScoreId: get(data, 'customCertificateScoreId.value'),
    customIssuePartyId: get(data, 'customIssuePartyId.value'),
    expiryDate: moment.isMoment(data.expiryDate)
      ? data.expiryDate.format('YYYY-MM-DD')
      : data.expiryDate,
    testDate: moment.isMoment(data.testDate) ? data.testDate.format('YYYY-MM-DD') : data.testDate,
  };
  if (data.id) {
    set(payload, 'id', data.id);
  }
  return payload;
};

const transformOtherData = (data) => {
  const payload = {
    customComplianceOtherDataTypeId: get(data, 'customComplianceOtherDataTypeId.value'),
    customIssuePartyId: get(data, 'customIssuePartyId.value'),
    description: data.description,
    name: data.name,
    expiryDate: moment.isMoment(data.expiryDate)
      ? data.expiryDate.format('YYYY-MM-DD')
      : data.expiryDate,
    result: data.result,
    testDate: moment.isMoment(data.testDate) ? data.testDate.format('YYYY-MM-DD') : data.testDate,
  };
  if (data.id) {
    set(payload, 'id', data.id);
  }
  return payload;
};

export const transformComplianceData = (data) => {
  return {
    ...data,
    testData: data.testData.map(transformTestData),
    certificateData: data.certificateData.map(transformCertificateData),
    otherData: data.otherData.map(transformOtherData),
  };
};
